import habitActionTypes from "./habits.types";

export const setHabits = (habits) => ({
  type: habitActionTypes.SET_HABITS,
  payload: habits,
});
